import React, { useRef, useEffect } from 'react';
import './DoBView.less';
import { FormikValues } from 'formik';
import { TextField } from '@mui/material';
import Box from '@mui/material/Box';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import NavigationBar from '../../../components/NavigationBar/NavigationBar';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import BrandButton from '../../../components/BrandButton/BrandButton';
import { isLocalizeAdded, LocalizePropType } from 'getaway-data-layer';
import { GA_TITLES } from '../../../../utils';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { de } from 'date-fns/locale';

type Props = {
  localize: LocalizePropType;
  formik: FormikValues;
  minDate: any;
  maxDate: any;
  onClose: () => void;
};

const DoBView = ({ localize, formik, minDate, maxDate, onClose }: Props) => {
  const datePickerRef = useRef(null);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const container = document.querySelector('[data-testid="DoBView-dob"]');
      if (container) {
        const inputElement = container.querySelector('input');
        if (inputElement) {
          inputElement.placeholder = localize('TT.MM.JJJJ');
        }
      }
    }, 100);

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <div className="screen-container">
      <NavigationBar
        TitleTestId="DoBView-title"
        DescriptionTestId="DoBView-description"
        title={localize('dob.title')}
        description={localize('dob.description')}
        showHelp
        showArrowBack
        onClose={onClose}
      />
      <div
        className={
          isLocalizeAdded(localize, 'dob.faq')
            ? 'screen-body-faq'
            : 'screen-body'
        }
      >
        <div
          className={
            isLocalizeAdded(localize, 'dob.faq')
              ? 'screen-body-content-faq'
              : 'screen-body-content'
          }
        >
          <Box component="form" noValidate onSubmit={formik.handleSubmit}>
            <div className="dob-date-wrapper">
              <LocalizationProvider dateAdapter={AdapterDateFns} locale={de}>
                <DesktopDatePicker
                  autoFocus={false}
                  showToolbar={false}
                  inputFormat="dd.MM.yyyy"
                  label={localize('dob.dateOfBirth.label')}
                  minDate={minDate}
                  maxDate={maxDate}
                  renderInput={(params: any) => (
                    <TextField
                      id="dob"
                      data-testid="DoBView-dob"
                      ref={datePickerRef}
                      {...params}
                      variant="standard"
                      sx={{
                        width: '100%',
                        borderBottomStyle: 'solid',
                      }}
                      error={formik?.errors?.dateOfBirth}
                      helperText={formik?.errors?.dateOfBirth}
                    />
                  )}
                  onChange={(value) => {
                    if (!value) {
                      formik.setFieldValue('dateOfBirth', '');
                    } else {
                      formik.setFieldValue('dateOfBirth', value);
                    }
                  }}
                  value={formik?.values?.dateOfBirth}
                  mask={'dd.MM.yyyy'.replace(/[a-zA-Z]/g, '_')}
                  PopperProps={{
                    placement: 'bottom-start',
                  }}
                />
              </LocalizationProvider>
            </div>
            <BrandButton
              id={GA_TITLES.ON_BOARDING.SUBMIT_SCHUFA}
              title={localize('dob.button.title')}
              formik={formik}
            />
          </Box>
        </div>
        {isLocalizeAdded(localize, 'dob.faq') && (
          <div className="faq">
            <Markdown rehypePlugins={[rehypeRaw]}>
              {localize('dob.faq')}
            </Markdown>
          </div>
        )}
        <div className="screen-vertical-space" />
      </div>
    </div>
  );
};

export default DoBView;
